import i18n from 'helper/i18n';
import appConfig from 'helper/mapBackendConfig';
import noop from 'helper/noop';
import { compileDynamicRoute } from 'helper/string';

// @ts-ignore
import IScroll, { IScrollInstanceType } from 'iscroll';
import $ from 'jquery';
import * as React from 'react';
import { HotKeys } from 'react-hotkeys';
import { withRouter } from 'react-router';
import TerrificBridge from 'react-terrific-bridge';

import { isNotEmptyObject } from '@impuls-coach/util-is';
import { CardTypes } from 'defs/card-types';
import { TrackingDescriptionIDType } from 'defs/tracking';
import { getMobileDevicePlatform, PLATFORMS } from 'helper/device';

import { CardTypeTypes } from 'types/Card';
import { CoachType } from 'types/coach';
import { WithRouterType } from 'types/withRouter';

import { Icon } from 'components/atoms/Icon/Icon';
import { Image, ImageProps } from 'components/atoms/Image';
import Knob from 'components/atoms/Knob/Knob';
import CardFavoriteNotification from 'components/molecules/Card/elements/FavoriteNotification';
import Loader from 'components/molecules/Card/Fragments/Loader';

import { WithFavoritePropsType } from 'components/hoc/Cards/withFavorite';
import { WithHandleCompletePropsType } from 'components/hoc/Cards/withHandleComplete';
import { WithHandleProductPropsType } from 'components/hoc/Cards/withHandleProduct';
import { TerrificActionEnumType } from 'components/hoc/Cards/withTerrificBridge';
import { WithTrackerPropsType } from 'components/hoc/Cards/withTracker';
import { WithUiStatePropsType } from 'components/hoc/Cards/withUiState';
import { WithLayoutPropsType } from 'components/hoc/withLayout';

import { CARD_RENDER_LOCATION, CardRenderLocationType } from 'containers/molecules/Card/enum-card-render-location';

import { createRef } from 'react';
import { Flipped } from 'react-flip-toolkit';
import { getMenuTypeLabel } from 'store/programItems';
import CardDetail from './Fragments/CardDetail';
import CardHeader from './Fragments/CardHeader';
import CategoryTitle from './Fragments/CategoryTitle';
import CompleteIcon from './Fragments/CompleteIcon';
import PlaceholderImage from './Fragments/PlaceholderImage';
import TopicIcon from './Fragments/TopicIcon';

export type CardStateTypes = 'feed' | 'folded' | 'reopened' | 'detail';

export const CardStates = {
	Feed: 'feed',
	Folded: 'folded',
	Reopened: 'reopened',
	Detail: 'detail',
};

export type CardProps = {
	childComponentRef: any;
	id: number;
	externalId: any;
	title?: string;
	state: CardStateTypes;
	currentDayNumber: number;
	type: CardTypeTypes;
	logo: ImageProps;
	coach?: CoachType;
	currentWeight?: number;
	thirdPartyLogo?: ImageProps;
	isMigustoRecipe: boolean;
	previewImage?: ImageProps;
	customWorkoutPreviewImage?: ImageProps;
	preselectedCustomWorkoutPreviewImage?: ImageProps;
	categoryIcon: string;
	productId?: string;
	disableRetailerContext?: boolean;
	isCheckable: boolean;
	isDayInFuture: boolean;
	isPostponed?: boolean;
	activeProgramId: number;
	activeProgramName: string;
	favorite: boolean;
	cardRenderLocation?: CardRenderLocationType;
	doToggleFavorite: Function;
	doAddEvents: Function;
	signature: string;
	programItemRef?: string;
	dayRef?: number;
	programItemExternalId: string;
	contentTypeExternalId: string;
	disablePostponeButton: boolean;
	setShuffelDomInner: any;
	setShuffelDomArticle: any;
	isLastDay: boolean;
	isToday: boolean;
	menuTypeLabel: ReturnType<typeof getMenuTypeLabel>;
	doOpenDescription: (guideId: TrackingDescriptionIDType) => void;
};

export type CardPropsMerged = CardProps &
	WithRouterType &
	WithUiStatePropsType &
	WithHandleCompletePropsType &
	WithFavoritePropsType &
	WithHandleProductPropsType &
	WithTrackerPropsType &
	WithLayoutPropsType;

export type IosScrollFixType = {
	iScrollInstance?: IScrollInstanceType;
	componentDidUpdate: (prevProps: CardPropsMerged) => void;
	componentDidMount: () => void;
	renderSpacerBottom: () => any;
	handleCardSloganFocus: (textareaDomElement: HTMLTextAreaElement) => void;
};

const stateClasses = {
	feed: 'state-m-card--feed',
	reopened: 'state-m-card--reopened',
	folded: 'state-m-card--folded',
	detail: 'state-m-card--detail',
	disabled: 'state-m-card--disabled',
};

const keyBoardMap = {
	closeOverlay: ['esc'],
};

export const contentStateClasses = {
	favorite: 'm-card__info--has-like',
};

export class Card extends React.Component<CardPropsMerged> {
	public static displayName = 'Card';
	public static defaultProps = {
		favorite: false,
		setShuffelDomInner: noop,
		setShuffelDomArticle: noop,
		doAddEvents: noop,
		disableRetailerContext: false,
	};

	/*
	 * DIRTY FIX: Use iScroll because of an bug on iPhone 6
	 * FIXME: maybe this could be removed after iPhone 6 is not used anymore
	 * @see https://jira.migros.net/browse/PULSWM-2992
	 */
	public iosScrollFix: IosScrollFixType = {
		iScrollInstance: undefined,
		componentDidMount: () => {
			if (!this.props.cardRenderLocation || this.props.cardRenderLocation === CARD_RENDER_LOCATION.PROGRAM_FEED) {
				return;
			}
			if (!this.isIOS || !this.scrollDomElement) {
				return;
			}
			setTimeout(() => {
				if (this.scrollDomElement) {
					this.iosScrollFix.iScrollInstance = new IScroll(this.scrollDomElement, {
						mouseWheel: true,
						scrollbars: false,
						click: true,
						tap: true,
					});
				}
			}, 0);
		},
		componentDidUpdate: (prevProps: CardPropsMerged) => {
			if (!this.isIOS) {
				return;
			}
			if (
				prevProps.uiState !== CardStates.Detail &&
				this.props.uiState === CardStates.Detail &&
				this.scrollDomElement
			) {
				setTimeout(() => {
					if (this.scrollDomElement) {
						this.iosScrollFix.iScrollInstance = new IScroll(this.scrollDomElement, {
							mouseWheel: true,
							scrollbars: false,
							click: true,
							tap: true,
						});
					}
				}, 0);
				return;
			}

			if (
				prevProps.uiState === CardStates.Detail &&
				this.props.uiState !== CardStates.Detail &&
				this.iosScrollFix.iScrollInstance
			) {
				const iScrollInstance: IScrollInstanceType = this.iosScrollFix.iScrollInstance;
				iScrollInstance.destroy();
				$(iScrollInstance.scroller).removeAttr('style');
			}
		},
		handleCardSloganFocus: (textareaDomElement) => {
			if (!this.iosScrollFix.iScrollInstance) {
				return;
			}

			const iScrollInstance = this.iosScrollFix.iScrollInstance;

			window.scrollTo(0, 0);
			(document.body || {}).scrollTop = 0;

			const $textarea = $(textareaDomElement);
			const $card = $textarea.closest('.m-card') as JQuery;
			const cardHeadHeight: number = $card.find('.m-card__head').height()!;
			const cardRichHeight: number = $card
				.find('.m-card__detail')
				.find('.m-rich')
				.height()!;
			const cardInfoHeight: number = $card.find('.m-card__info').height()!;

			iScrollInstance.scrollTo(0, (cardHeadHeight + cardRichHeight + cardInfoHeight + 60) * -1);
		},
		renderSpacerBottom: (): any => {
			return this.isInDetailView && this.isIOS ? <div style={{ height: 155 }} /> : null;
		},
	};

	private scrollDomElement: HTMLElement | null = undefined as any;

	private componentRef: React.RefObject<HTMLInputElement>;

	constructor(props: CardPropsMerged) {
		super(props);
		this.componentRef = createRef();
	}

	get modifier(): string | void {
		if (!this.props || !this.props.type) {
			return void 0;
		}
		return this.props.type === CardTypes.DynamicProduct ? 'product' : this.props.type;
	}

	get uiStateClass(): string | void {
		if (!this.props.uiState) {
			return void 0;
		}
		return stateClasses[this.props.uiState];
	}

	get futureVisibleCards(): string[] {
		return [CardTypes.Recipe, CardTypes.Workout];
	}

	get uiClasses(): string {
		let classes = 'm-card';

		if (this.modifier) {
			classes += ` m-card--${this.modifier}`;
		}

		if (this.props.isPostponed) {
			classes += ` state-m-card--postpone`;
		}

		if (this.props.isDayInFuture && !~this.futureVisibleCards.indexOf(this.props.type)) {
			classes += ` ${stateClasses.disabled}`;
		} else if (this.uiStateClass) {
			classes += ` ${this.uiStateClass}`;
		}

		return classes;
	}

	public shouldComponentUpdate({
		uiState,
		signature,
		showFavoriteNotification,
		disablePostponeButton,
	}: CardPropsMerged): boolean {
		if (this.props.uiState !== uiState) {
			return true;
		}

		if (this.props.disablePostponeButton !== disablePostponeButton) {
			return true;
		}

		if (this.props.showFavoriteNotification !== showFavoriteNotification) {
			return true;
		}

		return this.props.signature !== signature;
	}

	/*
	 * Register component in Terrific after mounted in DOM
	 * @fixes https://jira.migros.net/browse/PULSWM-2591
	 * @author Jan Biasi <jan.biasi@namics.com>
	 */
	public componentDidMount() {
		try {
			TerrificBridge.registerComponent(this.componentRef.current);
			if (this.props.childComponentRef) {
				this.props.childComponentRef(this);
			}
		} catch (e) {
			// do nothing
		}

		this.iosScrollFix.componentDidMount();
	}

	public componentWillUnmount() {
		TerrificBridge.unregisterComponent(this.componentRef.current);
		if (this.props.childComponentRef) {
			this.props.childComponentRef(null);
		}
	}

	get renderLocation(): CardRenderLocationType | void {
		return (this.props.cardRenderLocation as any) || CARD_RENDER_LOCATION.PROGRAM_FEED;
	}

	get isIOS(): boolean {
		return getMobileDevicePlatform() === PLATFORMS.IOS;
	}

	get isInDetailView(): boolean {
		return this.props.uiState === CardStates.Detail;
	}

	public componentDidUpdate(prevProps: CardPropsMerged) {
		this.iosScrollFix.componentDidUpdate(prevProps);
	}

	public renderLogo() {
		const { logo, isMigustoRecipe } = this.props;

		if (isNotEmptyObject(logo) && isMigustoRecipe) {
			return (
				<div className="m-card__logo">
					<Image {...logo} />
				</div>
			);
		}

		return null;
	}

	public renderPlaceholderImage() {
		if (this.renderLocation === CARD_RENDER_LOCATION.PROGRAM_FEED) {
			return (
				<PlaceholderImage type={this.props.type} previewImage={this.props.previewImage} id={this.props.id} />
			);
		}

		return null;
	}
	public fireTerrificAction(action: TerrificActionEnumType) {
		TerrificBridge.action(this.componentRef.current, action);
	}

	public renderCardDetail() {
		return (
			<CardDetail
				parentProps={this.props}
				cardRenderLocation={this.renderLocation as any}
				id={this.props.id}
				externalId={this.props.externalId}
				state={this.props.state}
				type={this.props.type}
				activeProgramId={this.props.activeProgramId}
				activeProgramName={this.props.activeProgramName}
				setCardUIFolded={this.props.onSetCardUIFolded}
				handleCardContentClick={this.props.onCardContentClick}
				handleShowDetailsClick={this.props.onShowDetailsClick}
				handleCompleteCard={this.props.onCompleteCard}
				handleCardSloganFocus={this.iosScrollFix.handleCardSloganFocus}
				isCheckable={this.props.isCheckable}
				uiState={this.props.uiState}
				productId={this.props.productId}
				favorite={this.props.favorite}
				coach={this.props.coach}
				currentWeight={this.props.currentWeight}
				doAddEvents={this.props.doAddEvents as any}
				dayRef={this.props.dayRef}
				programItemExternalId={this.props.programItemExternalId}
				contentTypeExternalId={this.props.contentTypeExternalId}
				onUpdateTerrificComponent={this.fireTerrificAction}
				onComplete={this.props.onComplete as any}
				isUiCompleting={this.props.isUiCompleting}
				onClickHeart={this.props.onClickHeart as any}
				onClickClose={this.props.onClickClose as any}
				onBackFromDetail={this.props.onBackFromDetail as any}
				isUiUpdatingHeart={this.props.isUiUpdatingHeart}
				isUiClosing={this.props.isUiClosing}
				handleToggleFavorite={this.props.handleToggleFavorite}
				trackCardTrackingSave={this.props.trackCardTrackingSave}
				doOpenDescription={this.props.doOpenDescription}
				history={this.props.history}
				location={this.props.location}
				match={this.props.match}
				programItemRef={this.props.programItemRef}
			/>
		);
	}

	public render() {
		const {
			type,
			isDayInFuture,
			productId,
			onCloseOverlay,
			disableRetailerContext,
			setShuffelDomInner = noop,
			setShuffelDomArticle = noop,
			showFavoriteNotification,
		} = this.props;
		const optionalRootProps = {};
		const isProduct = !!(type === CardTypes.DynamicProduct && !!productId);
		const handlers = {
			closeOverlay: onCloseOverlay,
		};

		if ((isProduct && isDayInFuture) || (isProduct && (!productId || productId.length === 0))) {
			return null;
		}

		if (isProduct) {
			// Product specific attributes
			optionalRootProps['data-product-id'] = productId;
			if (this.renderLocation === CARD_RENDER_LOCATION.PROGRAM_FEED) {
				if (disableRetailerContext) {
					optionalRootProps['data-disable-retailer-context'] = disableRetailerContext;
				}
			}

			if (this.renderLocation === CARD_RENDER_LOCATION.FAVORITE) {
				if (appConfig.views.Favorites.disableRetailerContext) {
					optionalRootProps['data-disable-retailer-context'] = disableRetailerContext;
				}
			}
		}

		let backHandler = this.props.onBackFromDetail;

		if (
			!!~[CARD_RENDER_LOCATION.POOL, CARD_RENDER_LOCATION.POOL_CUSTOM].indexOf(
				this.props.cardRenderLocation as CardRenderLocationType
			)
		) {
			const dedicatedPoolRoute = compileDynamicRoute(i18n('react.impulsCoach.routes.pool.cluster.href'), {
				selectedPool: i18n(`react.impulsCoach.routes.pool.selectedPool.${this.props.type}.href`),
				cluster: i18n('react.impulsCoach.routes.pool.cluster.all.href'),
			});

			backHandler = () => this.props.history.replace(dedicatedPoolRoute);
		}

		return (
			<Flipped flipId={this.props.id} key={this.props.id}>
				<div ref={this.componentRef} data-t-name="Card">
					<HotKeys
						ref={setShuffelDomArticle}
						className={this.uiClasses}
						keyMap={keyBoardMap}
						handlers={handlers}
						onClick={this.props.onCloseOverlayArticle}
						{...optionalRootProps}
						{
							...({ component: 'article' } as any) /* hack for ts compiler issues */
						}
					>
						<div className="m-card__back">
							<Knob modifier="filled" size="s" icon="back" onClick={backHandler} />
						</div>

						<CardFavoriteNotification
							visible={showFavoriteNotification}
							textSwitch={!!this.props.favorite}
						/>

						<div
							ref={(elem) => {
								this.scrollDomElement = elem;
							}}
							className="m-card__card"
						>
							<div className="m-card__scroll">
								<Loader />
								<div className="m-card__layer-icon">
									<Icon iconName={this.props.categoryIcon} />
								</div>
								<div ref={setShuffelDomInner} className="m-card__inner">
									{this.renderPlaceholderImage()}
									<div className="m-card__close js-m-card__close">
										<Knob modifier="filled" size="s" icon="close" onClick={this.props.onClose} />
									</div>
									<div className="m-card__category-icon">
										<Icon iconName={this.props.categoryIcon} />
									</div>
									<div className="m-card__topic">
										<CategoryTitle type={this.props.type} label={this.props.menuTypeLabel} />
										<TopicIcon categoryIcon={this.props.categoryIcon} />
										<CompleteIcon />
									</div>
									{this.renderLogo()}
									<div className="m-card__wrapper">
										<CardHeader {...this.props} />
										{this.renderCardDetail()}
									</div>
									{this.iosScrollFix.renderSpacerBottom()}
								</div>
							</div>
						</div>
					</HotKeys>
				</div>
			</Flipped>
		);
	}
}

export default withRouter(Card as any);
